<template>
  <ProductTabList :list="features">
    <template #after>
      <li
        v-if="documentUrls.length"
        class="product-tab-list__entry"
        data-testid="product-tab-list-downloads"
      >
        <strong class="product-tab-list__label">
          <template v-if="hasManyDocuments">Bedienungsanleitungen</template>
          <template v-else>Bedienungsanleitung</template>
        </strong>
        <ul class="product-tab-list__value list">
          <li
            v-for="(documentUrl, index) in documentUrls"
            :key="index"
          >
            <a
              :href="documentUrl"
              target="_blank"
              rel="noopener"
              data-tealium-rel="content.text.download"
              class="link"
            >
              Download
              <span v-if="documentUrls.length > 1">({{ index + 1 }})</span>
            </a>
          </li>
        </ul>
      </li>
    </template>
  </ProductTabList>
</template>

<script>
import ProductTabList from '~/components/product-detail/tabs/product-tab-list.vue';
import { attachmentUrl } from '~/lib/attachment-route';

export default {
  name: 'TechnicalDetails',
  components: { ProductTabList },
  props: {
    features: {
      type: Array,
      required: true,
    },
    documents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    documentUrls() {
      return this.documents.map((document) => attachmentUrl(document));
    },
    hasManyDocuments() {
      return this.documentUrls.length > 1;
    },
  },
};
</script>
